import React, {useState} from 'react';
import Chat from './Chat.js';
import Footer from './footer.js';
import {firebase, auth, db} from '../firebase.js';
import 'firebase/compat/database';
import 'firebase/compat/auth';
import {useCollectionData} from 'react-firebase-hooks/firestore';

function ChatRoom() {

    //Create a reference to our collection in the database
    var msgRef = db.collection("messages");

    //Apply the following query to database and store result in messages array using hook
    var query = msgRef.orderBy("createdAt", "desc").limit(15);
    var [messages] = useCollectionData(query);

    return (
        <>
            <div className="chatbox" id="chatbox">
                {messages && messages.map((item, index)=> <Chat key={index} item={item}/>)}
            </div>
            <Footer />
        </>
    )
}

export default ChatRoom;